module.exports = __webpack_public_path__ + "static/media/day.4f518377.png";